function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 387 319 387 319 629 100 629Z",
  fillRule: "evenodd",
  clipRule: "evenodd"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  transform: "translate(-100 -387)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M244.536 419.487 230.224 398.775 209.783 393.5 190.787 399.548 175.451 419.487 102.5 463.832 133.236 491.895 132.132 492.567 132.132 497.527 102.5 524.583 132.143 542.597 132.143 580.158 210.032 627.5 287.931 580.166 287.931 542.551 317.49 524.583 287.931 497.596 287.931 492.567 286.782 491.867 317.5 463.832 244.536 419.487ZM110.965 464.657 174.839 425.837C178.889 436.821 178.454 448.804 186.989 458.788L148.785 482.446 137.741 489.09 110.965 464.657ZM110.965 523.758 137.784 499.28 201.692 538.118 174.839 562.576 110.965 523.758ZM207.484 619.983 137.229 577.286 137.229 545.694 175.451 568.926 206.24 540.88 207.484 541.647 207.484 619.983ZM210.032 536.945 139.272 494.203 151.649 486.683 190.078 463.536 196.537 470.125 222.951 469.625 231.673 464.628 280.817 494.315 280.238 494.663 280.187 494.576 258.992 507.456 210.032 536.945ZM282.835 577.286 212.58 619.983 212.58 541.647 213.778 540.918 244.536 568.926 282.835 545.651 282.835 577.286ZM309.025 523.761 245.148 562.576 218.326 538.146 261.481 511.917 282.313 499.377 309.025 523.761ZM282.236 489.105 234.165 459.88 243.993 443.77 245.148 425.839 309.025 464.657 282.236 489.105Z",
  stroke: "#009999",
  strokeWidth: 1.33333,
  strokeMiterlimit: 8,
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.731 481 225.269 481C227.95 481 230 483.167 230 486 230 488.833 227.95 491 225.269 491L193.731 491C191.05 491 189 488.833 189 486 189 483.167 191.05 481 193.731 481Z",
  stroke: "#FFC000",
  strokeWidth: 2,
  strokeMiterlimit: 8,
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.731 497 225.269 497C227.95 497 230 499.167 230 502 230 504.833 227.95 507 225.269 507L193.731 507C191.05 507 189 504.833 189 502 189 499.167 191.05 497 193.731 497Z",
  stroke: "#FFC000",
  strokeWidth: 2,
  strokeMiterlimit: 8,
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199 514C199.485 519.1 204.008 523 209.5 523 214.992 523 219.516 519.1 220 514L199 514Z",
  stroke: "#FFC000",
  strokeWidth: 2,
  strokeMiterlimit: 8,
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.5 388C209.5 388 209.5 388 209.5 388 209.5 388 209.5 388 209.5 388 186.835 388.161 168.479 406.528 168 429.406L168 430.855C168.16 435.85 169.117 440.684 170.873 445.355 172.629 449.706 175.023 453.733 178.056 457.278 181.887 461.467 186.037 469.684 187.792 473.228 188.271 474.356 189.388 475 190.665 475L228.335 475C229.612 475 230.729 474.356 231.208 473.228 232.964 469.684 237.114 461.467 240.944 457.278 243.977 453.733 246.531 449.706 248.127 445.355 249.883 440.684 250.841 435.85 251 430.855L251 429.406C250.521 406.528 232.165 388.161 209.5 388ZM241.423 430.695C241.264 434.561 240.465 438.428 239.189 441.972 237.912 445.195 236.156 448.256 233.762 450.833 230.09 455.344 226.898 460.178 224.504 465.333L209.5 465.333 194.656 465.333C192.102 460.178 188.91 455.344 185.398 450.833 183.164 448.256 181.248 445.195 179.971 441.972 178.535 438.428 177.896 434.561 177.737 430.695L177.737 429.406C178.056 411.844 192.262 397.667 209.66 397.506L209.66 397.506 209.66 397.506C209.66 397.506 209.66 397.506 209.66 397.506 209.66 397.506 209.66 397.506 209.66 397.506L209.66 397.506 209.66 397.506C227.058 397.667 241.264 411.683 241.583 429.406L241.583 430.695Z",
  stroke: "#FFC000",
  strokeWidth: 2,
  strokeMiterlimit: 8,
  fill: "#FFFFFF",
  fillRule: "evenodd"
}));

var SvgIdeaboxLogo = function SvgIdeaboxLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 242,
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdeaboxLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ideabox-logo.20ef19b2.svg";
export { ForwardRef as ReactComponent };